document.addEventListener('DOMContentLoaded', function () {
    const columstrips = document.querySelectorAll('.columstrip');
    let currentIndex = 0;

    function showColumstrip(index) {
        columstrips.forEach((columstrip, i) => {
            if (window.innerWidth <= 1199) { 
                // Apply this only on screens below 1199px
                columstrip.style.display = (i === index) ? "flex" : "none";
            } else {
                // Ensure all are visible on larger screens
                columstrip.style.display = "flex";
                columstrip.style.opacity = "1";
            }
        });
    }

    function nextColumstrip() {
        currentIndex = (currentIndex + 1) % columstrips.length;
        showColumstrip(currentIndex);
    }

    // Initial display on load
    showColumstrip(currentIndex); 

    // Change slide every 3 seconds
    setInterval(nextColumstrip, 3000);

    // Re-evaluate on window resize
    window.addEventListener('resize', function() {
        showColumstrip(currentIndex);
    });
});



// document.addEventListener('DOMContentLoaded', function () {
//     const menuToggle = document.querySelector('.header__icon--menu');
//     const searchBar = document.querySelector('.mobile-search-bar');

//     menuToggle.addEventListener('click', function () {
//         if (searchBar.style.display === 'none' || !searchBar.style.display) {
//             searchBar.style.display = 'flex';
//         } else {
//             searchBar.style.display = 'none';
//         }
//     });
// });

/* ---- Vivid mega-menu thumbnails: load-on-interaction ----
   Thumbnails are deferred in snippets/header-mega-menu.liquid via a
   1x1 placeholder src + data-mmsrc. They swap in when the visitor first
   interacts with the desktop menu (no page-wide prefetch since 24 Sep 2026, report 48). */
(function () {
  function loadScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var ims = scope.querySelectorAll('img.mm-lazy[data-mmsrc]');
    for (var i = 0; i < ims.length; i++) {
      var im = ims[i];
      var u = im.getAttribute('data-mmsrc');
      if (!u) continue;
      im.src = u;
      im.removeAttribute('data-mmsrc');
      im.classList.remove('mm-lazy');
    }
  }
  function nearestMenu(t) {
    return (t && t.closest) ? t.closest('.header__inline-menu li, .header__inline-menu header-menu, .header__inline-menu details') : null;
  }
  var warmed = false;
  function warmNav() {
    /* first real interaction with the desktop menu: the other menus' thumbnails follow shortly after,
       so the next panel the visitor opens is already filled in */
    if (warmed) return; warmed = true;
    setTimeout(function () { loadScope(document.querySelector('.header__inline-menu')); }, 300);
  }
  function onEnter(e) { var m = nearestMenu(e.target); if (m) { loadScope(m); warmNav(); } }
  document.addEventListener('mouseover', onEnter, true);
  document.addEventListener('pointerover', onEnter, true);
  document.addEventListener('focusin', onEnter, true);
  document.addEventListener('touchstart', onEnter, true);
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.header__inline-menu')) loadScope(t);
  }, true);
  /* 24 Sep 2026 (report 48): the automatic prefetch (all menus' images 2.5 s after load, or on the
     first scroll / mouse move / key press) was removed. It downloaded ~54 images (~0.5 MB) on almost
     every desktop visit. Images now load only once the visitor points at, focuses, taps or opens a menu: that menu at once,
     the other menus 300 ms later (warmNav). Visitors who never touch the menu download none. */
})();
